import { render, staticRenderFns } from "./TradingEchartsPie.vue?vue&type=template&id=4b8f59c1&scoped=true&"
import script from "./TradingEchartsPie.vue?vue&type=script&lang=js&"
export * from "./TradingEchartsPie.vue?vue&type=script&lang=js&"
import style0 from "./TradingEchartsPie.vue?vue&type=style&index=0&id=4b8f59c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f59c1",
  null
  
)

export default component.exports